import React from "react"
import { css } from "@jsUtils"
import Styles from "./circlesburst.module.scss"

const COLORS = {}
COLORS.black = "#000000"
COLORS.white = "#ffffff"
COLORS.dark = "#384049"
COLORS.slate = "#505c69"

COLORS.tin = "#c1ccd4"
COLORS.blue = "#24b0ff"
COLORS.fluro = "#10f8e4"
COLORS.works = "#6864dd"
COLORS.cinnabar = "#ec373c"

COLORS.midsommar = "#22688a"
COLORS.inky = "#0c00c2"
COLORS.purple = "#5b44e7"
COLORS.pink = "#c659f7"

const CirclesBurst = props => {
  const { ready, size, color } = props

  const circleStyle = {
    backgroundColor: COLORS[color]
  }
  return (
    <div
      style={circleStyle}
      className={css(Styles.circle, Styles[`size__${size}`], ready && Styles.ready)}
    />
  )
}

export default CirclesBurst
